module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/104-ecuador-40dfef4415460bc68cbb74664bb93089.svg";